module.exports = __webpack_public_path__ + "media/v2/mail-v2-e55a95b9.svg";